import { useParams, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Issue from "./Issue";
import Articleid from "./Articleid/Articleid";

const DynamicRoute = () => {
  const { article } = useParams();
  //   console.log(article);
  const location = useLocation();
  const abstarct = location.state?.abstract || "";
  const keywords = location.state?.keywords || "";



  // Determine the title dynamically
  const getTitle = () => {
    if (article) {
      return `${article
        .split("-")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ")} - Journal of Applied Bioanalysis`;
    } else {
      return "Journal of Applied Bioanalysis";
    }
  };

  return (
    <>
      <Helmet>
        <title>{getTitle()}</title>
        <meta name="abstract" content={abstarct} />
      <meta property="og:titles" content={getTitle()} />
      <meta property="og:keywords" content={keywords} />

      </Helmet>
      {location.pathname.startsWith("/journal-of-applied-bioanalysis") ? (
        <Issue />
      ) : (
        <Articleid />
      )}
    </>
  );
};

export default DynamicRoute;
